import { UPDATE_TOP_SKUS_WIDGET } from "./actionTypes";

const initialState = {
  data : {}
};

const topSkusWidget = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_TOP_SKUS_WIDGET:
      state = { ...state, data: action.payload};
      break;
    
    default:
      break;
  }
  return state;
};

export default topSkusWidget;
